import React from 'react';
import WName, {WArticle} from '../WName';
import Eon, {EonArticle} from '../Eon';
import PL from '../problems/ProblemLink';
import QL from '../faq/QuestionLink';
import LRL from '../longreads/LongReadLink';
import OML from '../ormaybe/OrMaybeLink';
import AL from './AngleLink';
import NW from '../neologisms/NewWord';
import {E1, E2, Qual, Fibonacci} from '../common';

// All the people
export const people = {
  name: "people",
  alternatives: "p",
  header: <span>
    <WName cap noNW /> can engage with humanity’s past.
  </span>,
  preview: <div className="angle-preview">
    <p>An ‘<PL>individual</PL>’ is just a <i>memory</i>.</p>
    <p>If we are <i>pre-determined</i> by our past, then we are just <LRL>reactivity</LRL>. If we ignore our past altogether, the word for that one is ‘idiot’. But if we are <i>informed</i> by our past, and then <i>keep growing</i>?</p>
    <p>That’s <WName />.</p>
  </div>,
//  text: <div className="angle-text">  
//  </div>,
  sublist: [
  // Hannah Arendt
  {
    name: "arendt",
    alternatives: "hannah arendt",
    header: <span>
      What is the ‘banality of evil’
    </span>,
    preview: <div className="angle-preview">
      <p>In the 20<sup>th</sup> century, philosopher Hannah Arendt became (in)famous for the phrase ‘the banality of <PL>evil</PL>’. WHy, and what does it really (<WName ically />) mean?</p>
      <p>It has to do with our literal war – as <QL>consciousness</QL> – against <LRL>reactivity</LRL>. Because – contrary to what <AL name="handicap">hominids</AL> <i><PL name="uncomfortable">like</PL></i> to think (cf. our allergy to <PL>accountability</PL>) – there is no ‘grand plan’ of the enemy. The enemy is <PL>fear</PL>, inertia, <PL>fear</PL>, <AL name="peace">stillness</AL> (not <i><QL name="salvation.">actually thinking</QL></i>), <PL>fear</PL>, the <PL name="explainage">friction</PL> of <NW>polygnosticity</NW> (cf. ‘<AL name="notnew.p.huxley">island universes</AL>’), and, of course, <PL>fear</PL>.</p>
      <p>If we do nothing, the enemy wins. So <PL>evil</PL> (whatever the old version of this site says) is not a <i>decision</i>. It’s the <i>lack</i> of one (cf. <NW>APE</NW>).</p>
    </div>,
//    text: <div className="angle-text">  
//    </div>,
  },

  // Carl Popper
  {
    name: "popper",
    alternatives: "karl popper",
    header: <span>
      Is <WName noNW /> <i>falsifiable</i>?
    </span>,
    preview: <div className="angle-preview">
      <p>Karl popper was a scientist and actual <i><QL name="salvation.thinking">thinker</QL></i> who – in the 20<sup>th</sup> century – introduced the <LRL>notion</LRL> to <QL name="anthropocentrism">humanity</QL> (later formalised in the <LRL>nepantla</LRL> proof) that you can never, by process of elimination from every <i>possible</i> <E2 word="explanation" />, reach a <QL>definitive</QL> answer. In short: you could only <i>falsify</i> things (prove inconsistemcies, cf. <PL>ZFC</PL>); <NW>induction</NW> (and the <AL name="fields.sciece">scientific method</AL>) <i>could not give difinite answers</i>.</p>
      <p>In not ‘response’ but <i><LRL name="reactivity">reaction</LRL></i>, humanity FREAKED OUT (cf. <i><PL>fear</PL></i>) and then ATE OUR OWN TAIL (cf. <NW word="jorm">Jörmungandr</NW>) and then decided there must be an  <PL name="ignorabimus">UNKNOWABLE</PL> to account for it (cf. <LRL name="nepantla.false.godel">Gödel</LRL>) – and the ‘logical positivists’ of that day (who had the right idea that everything could be <LRL name="understand">understood</LRL>, but they thought that meant that everything could be and should be <QL name="rigidbox">RigidBoxed</QL><sup></sup>) had a big  ‘falling out’ with him or whatever.</p>
      <p>[Maybe to be updated lated if a <NW>zyzzyva</NW> ever <i><QL name="salvation.thinking">actually thinks</QL></i> about this but <AL name="straitjacket">rushing rushing rushing <i>can’t think</i>, rushing rushing rushing</AL>—]</p>
    </div>,
//    text: <div className="angle-text">  
//    </div>,
  },


  ],
};

